import { FLAG_SCOPES } from '../scopes';

/**
 * Core team-owned Vercel Flag keys.
 *
 * Import and use these constants at both the config site (below) and consumer
 * sites (`useFlag(CORE_FLAGS.AI_ASSISTANT)` / `getFlag(req, CORE_FLAGS.AI_ASSISTANT)`)
 * to keep keys in one place.
 */
export const CORE_FLAGS = {
  AI_ASSISTANT: 'getapp-ai-assistant',
  PPL_PRICING_BANNER: 'getapp-ppl-pricing-banner',
  OSANO_CMP_PRIMARY: 'getapp-osano-cmp-primary',
};

const ALL_FLAGS = [
  {
    key: CORE_FLAGS.PPL_PRICING_BANNER,
    defaultValue: -1,
    description:
      'A/B experiment: PPL advisors banner below pricing plan cards on GetApp profile pages',
    options: [
      { value: -1, label: 'Off' },
      { value: 0, label: 'Control' },
      { value: 1, label: 'Variant' },
    ],
    tracked: true,
    scopes: [FLAG_SCOPES.PRODUCT],
  },
  {
    key: CORE_FLAGS.OSANO_CMP_PRIMARY,
    defaultValue: -1,
    description:
      'GetApp CMP kill switch: -1 keeps current OneTrust behavior, 1 enables Osano as primary.',
    options: [
      { value: -1, label: 'OneTrust Primary' },
      { value: 1, label: 'Osano Primary' },
    ],
    tracked: false,
    scopes: [FLAG_SCOPES.GLOBAL],
  },
  {
    key: CORE_FLAGS.AI_ASSISTANT,
    defaultValue: -1,
    description: 'A/B experiment for the AI Assistant chat widget',
    options: [
      { value: -1, label: 'Off' },
      { value: 0, label: 'Control' },
      { value: 1, label: 'Variant' },
    ],
    tracked: true,
    scopes: [FLAG_SCOPES.GLOBAL],
    includePaths: [],
    excludePaths: [],
  },
];

export default ALL_FLAGS;
